import type {
  ApiResponse,
  GetTokenSymbolType,
  GetWalletHistoryType,
  UserBalancesType,
} from '@asetquhub/validation';
import { api } from '../lib/axios';

const getTokenSymbol = async (): Promise<GetTokenSymbolType | null> => {
  const response = await api.get<ApiResponse<GetTokenSymbolType>>('/api/wallet/symbol');
  return response.data.data ?? null;
};

const getUserBalances = async (): Promise<UserBalancesType | null> => {
  const response = await api.get<ApiResponse<UserBalancesType>>('/api/wallet/balance');
  return response.data.data ?? null;
};

const getWalletHistory = async (limit?: number): Promise<GetWalletHistoryType | null> => {
  const url = limit ? `/api/wallet/history?limit=${limit}` : '/api/wallet/history?limit=10';
  const response = await api.get<ApiResponse<GetWalletHistoryType>>(url);
  return response.data.data ?? null;
};

const getFullWalletHistory = async (): Promise<GetWalletHistoryType | null> => {
  const response = await api.get<ApiResponse<GetWalletHistoryType>>(
    '/api/wallet/history?limit=100'
  );
  return response.data.data ?? null;
};

const getGasPrice = async (): Promise<string | null> => {
  const response = await api.get<ApiResponse<{ gasPrice: string }>>('/api/wallet/gas-price');
  return response.data.data?.gasPrice ?? null;
};

/**
 * Transfer request with signature
 */
export type TransferRequest = {
  to: string;
  amount: string;
  message: string;
  signature: string;
};

/**
 * Transfer response
 */
export type TransferResponse = {
  txHash: string;
  transactionId: string;
  status: 'BROADCASTING';
  from: string;
  to: string;
  amount: string;
  message: string;
};

const transfer = async (data: TransferRequest): Promise<TransferResponse> => {
  const response = await api.post<ApiResponse<TransferResponse>>('/api/wallet/transfer', data);
  return response.data.data!;
};

export const walletService = {
  getTokenSymbol,
  getUserBalances,
  getWalletHistory,
  getFullWalletHistory,
  getGasPrice,
  transfer,
};
